<template>
  <component :is="drawer ? 'div' : 'page-header-wrapper'">
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsSpecSame.query.specCombinationList')" prop="specCombinationList">
                  <a-input v-model="queryParam.specCombinationList" :placeholder="$t('views.goodsSpecSame.query.specCombinationListPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsSpecSame.query.sort')" prop="sort">
                  <a-input v-model="queryParam.sort" :placeholder="$t('views.goodsSpecSame.query.sortPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.goodsSpecSame.btn.query') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAddWithGoodsId" v-hasPermi="['user:goodsSpecSame:add']">
          <a-icon type="plus" />{{ $t('views.goodsSpecSame.btn.add') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:goodsSpecSame:edit']">
          <a-icon type="edit" />{{ $t('views.goodsSpecSame.btn.edit') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:goodsSpecSame:remove']">
          <a-icon type="delete" />{{ $t('views.goodsSpecSame.btn.delete') }}
        </a-button>
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status == 1 || record.status == '1'"
            @change="(checked) => handleStatusChange(record, checked)"
          />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['user:goodsSpecSame:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:goodsSpecSame:edit']">
            <a-icon type="edit" />{{ $t('views.goodsSpecSame.btn.edit') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['user:goodsSpecSame:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['user:goodsSpecSame:remove']">
            <a-icon type="delete" />{{ $t('views.goodsSpecSame.btn.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="paginationShowTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </component>
</template>

<script>
import { pageGoodsSpecSame, delGoodsSpecSame, updateGoodsSpecSame } from '@/api/user/goodsSpecSame'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'GoodsSpecSame',
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    goodId: {
      type: [String, Number],
      default: null
    }
  },
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        goodId: null,
        specCombinationId: null,
        specCombinationList: null,
        sort: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: []
    }
  },
  created () {
    this.buildColumns()
    if (this.goodId !== null && this.goodId !== undefined && this.goodId !== '') {
      this.queryParam.goodId = this.goodId
    }
    this.getList()
  },
  watch: {
    '$i18n.locale' () {
      this.buildColumns()
    },
    goodId: {
      immediate: false,
      handler (val) {
        if (val === null || val === undefined || val === '') {
          return
        }
        this.queryParam.goodId = val
        this.queryParam.pageNum = 1
        this.getList()
      }
    }
  },
  methods: {
    buildColumns () {
      const t = k => this.$t(k)
      this.columns = [
        { title: t('views.goodsSpecSame.column.id'), dataIndex: 'id', ellipsis: true, align: 'center' },
        { title: t('views.goodsSpecSame.column.goodSpecName'), dataIndex: 'goodSpecName', ellipsis: true, align: 'center' },
        { title: t('views.goodsSpecSame.column.specOptionName'), dataIndex: 'specOptionName', ellipsis: true, align: 'center' },
        { title: t('views.goodsSpecSame.column.specCombinationNameList'), dataIndex: 'specCombinationNameList', ellipsis: true, align: 'center' },
        {
          title: t('views.goodsSpecSame.column.status'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.goodsSpecSame.column.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.goodsSpecSame.column.operation'),
          dataIndex: 'operation',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    },
    paginationShowTotal (total) {
      return this.$t('views.goodsSpecSame.pagination.total', { total })
    },
    handleAddWithGoodsId () {
      if (this.$refs.createForm && this.$refs.createForm.handleAdd) {
        this.$refs.createForm.handleAdd({
          id: this.goodId
        })
      }
    },
    getList () {
      this.loading = true
      pageGoodsSpecSame(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        goodId: undefined,
        specCombinationId: undefined,
        specCombinationList: undefined,
        sort: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('views.goodsSpecSame.confirm.deleteTitle'),
        content: this.$t('views.goodsSpecSame.confirm.deleteContent', { ids: String(ids) }),
        onOk () {
          let data = []
          that.ids.map(id => data.push({ id: id }))
          return delGoodsSpecSame(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('views.goodsSpecSame.msg.deleteOk'),
                3
              )
            })
        },
        onCancel () {
          that.ids = []
        }
      })
    },
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('views.goodsSpecSame.confirm.exportTitle'),
        content: this.$t('views.goodsSpecSame.confirm.exportContent'),
        onOk () {
          that.download('user/goods-spec-same/export', {
            ...that.queryParam
          }, `${that.$t('views.goodsSpecSame.export.filenamePrefix')}_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    handleStatusChange (record, checked) {
      const statusValue = checked ? 1 : 0
      const updateData = {
        id: record.id,
        status: statusValue
      }
      updateGoodsSpecSame(updateData).then(() => {
        record.status = statusValue
        this.$message.success(this.$t('views.goodsSpecSame.msg.statusOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.goodsSpecSame.msg.statusFail'))
      })
    },
  }
}
</script>
